var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarketo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "#5c4c9f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4 50.972V8.892L43.055 0v64zM22.276 5.563l13.17 3.9v40.56l-13.17 5.753zm-7.608 8.274L4.636 12.22l-.048 36.327 10.08-2.663z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketo);
export default __webpack_public_path__ + "static/media/marketo.48aaef84b17871fac265e26c66e14e20.svg";
export { ForwardRef as ReactComponent };